<template>
  <div>
    <form @submit.prevent="handleFormSubmit" class="form">
      <register-title class="form__title">{{
        $t("register info")
      }}</register-title>
      <!--------------------------------------------------------   SHORT NAME   ----->
      <register-input
        componentID="short_name"
        inputType="text"
        :label="$t('short name')"
        :inputPlaceholder="$t('short name')"
        :isRequired="true"
        v-model="form.legal_short_name"
        class="form__input"
      />
      <!--------------------------------------------------------   LEGAL TYPE    ----->
      <register-input
        componentID="legal _type"
        inputType="text"
        :label="$t('legal form')"
        :inputPlaceholder="$t('legal form')"
        :isRequired="true"
        v-model="form.legal_type"
        class="form__input"
      />
      <div class="select-container">
        <label class="label">{{ $t("register document type") }}</label>
        <exp-select
          :options="registrationDocumentTypesList"
          v-model="form.document_type"
          :title="$t('choose country')"
        ></exp-select>
      </div>
      <!--------------------------------------------------------   DOC PASSPORT NUMBER   ----->
      <div>
        <div v-if="isKazDoc(form.document_type)">
          <label for="user-phone" class="label">
            {{ $t("id document number") }}
            <span class="red">*</span>
          </label>
          <input
            type="number"
            class="input form__input"
            :placeholder="$t('id document number')"
            required
            v-model="form.document_number"
            @keyup="formatDocNumber"
            @blur="formatDocNumber"
          />
        </div>
        <register-input
          v-else
          v-model="form.document_number"
          componentID="number_2"
          inputType="text"
          :label="$t('document number')"
          :inputPlaceholder="$t('document number')"
          :isRequired="true"
          class="form__input"
        />
      </div>
      <!--------------------------------------------------------   ISSUE DATE (START)    ----->
      <register-input
        v-model="form.document_issued_at"
        componentID="issue-date"
        inputType="date"
        :maxDate="new Date()"
        :label="$t('document issuing date')"
        :isRequired="true"
        class="form__input"
      />
      <!--------------------------------------------------------   PLace reg   ----->
      <register-input
        componentID="place_reg"
        inputType="text"
        :label="$t('register location')"
        :inputPlaceholder="$t('register location')"
        :isRequired="true"
        v-model="form.legal_registrar"
        class="form__input"
      />
      <!--------------------------------------------------------   SHORT NAME   ----->
      <register-input
        componentID="website"
        inputType="url"
        :label="$t('internet resource name')"
        :inputPlaceholder="$t('website link')"
        :isRequired="false"
        v-model="form.website"
        class="form__input"
      />
      <file-input
        :mini="true"
        :is_uploaded="form_files.legal_charter"
        v-model="form_files.legal_charter"
        @attached="saveFile(form_files.legal_charter, 'legal_charter')"
        class="form__input-container"
        componentID="doc_1"
      >
        {{ $t("charter le / Regulation branch or representative office") }}
      </file-input>
      <file-input
        :mini="true"
        :is_uploaded="form_files.legal_registration_state"
        v-model="form_files.legal_registration_state"
        @attached="
          saveFile(
            form_files.legal_registration_state,
            'legal_registration_state'
          )
        "
        class="form__input-container"
        componentID="doc_2"
      >
        {{ $t("state register certificate") }}
      </file-input>
      <button class="button filled form__button">{{ $t("confirm") }}</button>
    </form>
  </div>
</template>

<script>
import regFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";

export default {
  props: ["user_profile"],
  name: "MainRegForm",
  data() {
    return {
      old_form: {},
      form: {
        legal_short_name: null,
        legal_type: null,
        document_type: null,
        document_issued_at: null,
        document_number: null,
        legal_registrar: null,
        website: null
      },
      form_files: {
        legal_charter: null,
        legal_registration_state: null
      },
      form_dates: ["document_issued_at"]
    };
  },
  mixins: [regFormMixin],
  watch: {
    user_profile: function(value) {
      this.fetchForm();
    }
  },
  methods: {
    formatDocNumber() {
      this.form.document_number = this.form.document_number.replace(/\D/g, "");
      this.form.document_number = this.form.document_number.substr(0, 9);
    },
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    fetchForm() {
      try {
        Object.entries(this.user_profile.userProfile).map(obj => {
          if (obj[0] in this.form) {
            this.form[obj[0]] = obj[1];
          }
        });
        Object.entries(this.form_files).map(obj => {
          let find_file = this.user_profile.userUploadedDocuments.find(
            file => file.type === obj[0]
          );
          this.form_files[obj[0]] = (find_file ? true : null) || null;
        });
        this.form_dates.forEach(date => {
          this.form[date] = this.dateFormat(this.form[date]);
        });
        // console.log(this.isKazDoc(this.form.document_type));
        this.old_form = JSON.parse(JSON.stringify(this.form));
      } catch (e) {
        // ERROR HANDLER
      }
    },
    isFilesAdded() {
      return (
        this.form_files.legal_charter &&
        this.form_files.legal_registration_state
      );
    },
    nextStep() {
      this.$router.push({ name: "legal-entity-license" });
    },
    saveData() {
      let url = `user/profile`;
      const form = JSON.parse(JSON.stringify(this.form));
      this.form_dates.forEach(date => {
        form[date] = this.dateReFormat(form[date]);
      });
      FhsAxios.post(url, form).then(res => {
        if (res.data.status) {
          this.$toasted.success(this.$t("data saved"));
          this.nextStep();
          return;
        }
        this.$toasted.error(this.$t("error"));
        this.$emit("loading-status", false);
      });
    },
    handleFormSubmit() {
      if (this.isFilesAdded()) {
        this.saveData();
      } else {
        this.$toasted.clear();
        this.$toasted.show("attach files");
      }
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>
